/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessGetDirectoryReviewSettings } from "../funcs/accessGetDirectoryReviewSettings.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { DirectoryReviewSettings } from "../models/components/directoryreviewsettings.js";
import {
  GetDirectoryReviewSettingsRequest,
  GetDirectoryReviewSettingsSecurity,
} from "../models/operations/getdirectoryreviewsettings.js";
import { unwrapAsync } from "../types/fp.js";
export type DirectoryReviewSettingsQueryData = DirectoryReviewSettings;

export function prefetchDirectoryReviewSettings(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetDirectoryReviewSettingsRequest | undefined,
  security?: GetDirectoryReviewSettingsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildDirectoryReviewSettingsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildDirectoryReviewSettingsQuery(
  client$: GramCore,
  request?: GetDirectoryReviewSettingsRequest | undefined,
  security?: GetDirectoryReviewSettingsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<DirectoryReviewSettingsQueryData>;
} {
  return {
    queryKey: queryKeyDirectoryReviewSettings({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function directoryReviewSettingsQueryFn(
      ctx,
    ): Promise<DirectoryReviewSettingsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessGetDirectoryReviewSettings(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyDirectoryReviewSettings(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "getDirectoryReviewSettings", parameters];
}
